export default (props) => (
  /**
   * Icone da ferramenta de interseção.
   * Responsavel por iniciar operação de interseção sobre 
   * feições de uma ou duas camadas
   */
  <svg
    width={23}
    height={20}
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3394 6.6875L14.5148 1.1875C14.8997 0.520834 15.862 0.520833 16.2469 1.1875L22.7421 12.4375C23.127 13.1042 22.6458 13.9375 21.876 13.9375H14.8809V17.6875C14.8809 18.7921 13.9854 19.6875 12.8809 19.6875H2.88086C1.77629 19.6875 0.880859 18.7921 0.880859 17.6875V8.6875C0.880859 7.58293 1.77629 6.6875 2.88086 6.6875H11.3394ZM13.0665 6.696L15.3808 2.6875L21.01 12.4375H14.8809V8.6875C14.8809 7.64553 14.0841 6.78967 13.0665 6.696ZM10.4734 8.1875H2.88086C2.60472 8.1875 2.38086 8.41136 2.38086 8.6875V17.6875C2.38086 17.9636 2.60472 18.1875 2.88086 18.1875H12.8809C13.157 18.1875 13.3809 17.9636 13.3809 17.6875V13.9375H8.88565C8.11585 13.9375 7.63472 13.1042 8.01962 12.4375L10.4734 8.1875Z"
      fill="#BEC7DC"
    />
  </svg>
);
